<template>
  <div id="operaciones-ver">
    <vx-card>
      <div class="mb-2 text-center item-features">
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full">
            <div class="w-64 mx-auto mb-16 md:mb-0">
              <feather-icon icon="UserIcon" 
                v-bind:svgClasses="[operacion.porcentajeCompletado>=25 ? 'h-8 w-8 text-success stroke-current' : 'h-8 w-8 textoGris stroke-current']" 
                class="block mb-2" 
              />
              <span v-bind:class="[operacion.porcentajeCompletado>=25 ? 'font-semibold text-success' : 'font-semibold textoGris']">Datos de la operación</span>
              <p v-if="operacion.porcentajeCompletado===25" class="text-success">25% operación completa</p>
            </div>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <div class="w-64 mx-auto mb-16 md:mb-0">
              <feather-icon icon="ShoppingCartIcon" 
                v-bind:svgClasses="[operacion.porcentajeCompletado>=50 ? 'h-8 w-8 text-success stroke-current' : 'h-8 w-8 textoGris stroke-current']" 
                class="block mb-2" 
              />
              <span v-bind:class="[operacion.porcentajeCompletado>=50 ? 'font-semibold text-success' : 'font-semibold textoGris']">Productos</span>
              <p v-if="operacion.porcentajeCompletado===50" class="text-success">50% operación completa</p>
            </div>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <div class="w-64 mx-auto mb-16 md:mb-0">
              <feather-icon icon="InfoIcon" 
                v-bind:svgClasses="[operacion.porcentajeCompletado>=75 ? 'h-8 w-8 text-success stroke-current' : 'h-8 w-8 textoGris stroke-current']" 
                class="block mb-2" 
              />
              <span v-bind:class="[operacion.porcentajeCompletado>=75 ? 'font-semibold text-success' : 'font-semibold textoGris']">Detalle productos</span>
              <p v-if="operacion.porcentajeCompletado===75" class="text-success">75% operación completa</p>
            </div>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <div class="w-64 mx-auto mb-16 md:mb-0">
              <feather-icon icon="FileTextIcon" 
                v-bind:svgClasses="[operacion.porcentajeCompletado===100 ? 'h-8 w-8 text-success stroke-current' : 'h-8 w-8 textoGris stroke-current']" 
                class="block mb-2" 
              />
              <span v-bind:class="[operacion.porcentajeCompletado===100 ? 'font-semibold text-success' : 'font-semibold textoGris']">Documentación</span>
              <p v-if="operacion.porcentajeCompletado===100" class="text-success">100% operación completa</p>
            </div>
          </div>
        </div>
      </div>
      <vs-progress class="md:w-4/4" :height="20" :percent="operacion.porcentajeCompletado" color="success">{{operacion.porcentajeCompletado}}%</vs-progress>
      
      <vs-divider />

      <vs-tabs v-model="SolapaActiva" class="tab-action-btn-fill-conatiner">
        <!-- Operación -->
        <vs-tab label="Operación" icon-pack="feather" icon="icon-book-open">
          <div class="tab-text">
            <operaciones-view-operacion class="mt-4" />
          </div>
        </vs-tab>
        <!-- Cliente -->
        <vs-tab label="Cliente" icon-pack="feather" icon="icon-user">
          <div class="tab-text">
            <operaciones-view-cliente class="mt-4" />
          </div>
        </vs-tab>
        <!-- Decisor -->
        <vs-tab label="Decisor" icon-pack="feather" icon="icon-users">
          <div class="tab-text">
            <operaciones-view-decisor class="mt-4" />
          </div>
        </vs-tab>
        <!-- Dirección instalación -->
        <vs-tab label="Dir. Instalación" icon-pack="feather" icon="icon-map-pin">
          <div class="tab-text">
            <operaciones-view-direccion class="mt-4" />
          </div>
        </vs-tab>
        <!-- Productos -->
        <vs-tab label="Productos" icon-pack="feather" icon="icon-shopping-cart">
          <div class="tab-text">
            <operaciones-view-productos class="mt-4" />
          </div>
        </vs-tab>
        <!-- Productos detalle-->
        <vs-tab label="Detalle de productos" icon-pack="feather" icon="icon-info">
          <div class="tab-text">
            <operaciones-view-productos-detalle class="mt-4" />
          </div>
        </vs-tab>
        <!-- Documentación  -->
        <vs-tab label="Documentación" icon-pack="feather" icon="icon-file-text">
          <div class="tab-text">
            <operaciones-view-documentacion class="mt-4" />
          </div>
        </vs-tab>
        <!-- Comentarios  -->
        <vs-tab label="Comentarios" icon-pack="feather" icon="icon-message-square">
          <div class="tab-text">
            <operaciones-view-comentarios class="mt-4" />
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'

import operacionesViewOperacion from './OperacionesViewOperacion'
import operacionesViewCliente from './OperacionesViewCliente'
import operacionesViewDecisor from './OperacionesViewDecisor'
import operacionesViewDireccion from './OperacionesViewDireccion'
import operacionesViewProductos from './OperacionesViewProductos'
import operacionesViewProductosDetalle from './OperacionesViewProductosDetalle'
import operacionesViewDocumentacion from './OperacionesViewDocumentacion'
import operacionesViewComentarios from './OperacionesViewComentarios'

export default {
  name: 'OperacionesView',
  components: {
    operacionesViewOperacion,
    operacionesViewCliente,
    operacionesViewDecisor,
    operacionesViewDireccion,
    operacionesViewProductos,
    operacionesViewProductosDetalle,
    operacionesViewDocumentacion,
    operacionesViewComentarios
  },
  data () {
    return {
      operacion: null,
      SolapaActiva: 0
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))

    this.$vs.loading.close()
  }
}
</script>